import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
import { Icon, divIcon, point } from "leaflet";
import "./Style/map.css";
const MapIraq = () => {
  const markers = [
    {
      id: 1,
      geocode: [36.1545556, 44.0608333],
      popUp: "هەولێر", // Popup for Erbil
    },
    {
      id: 2,
      geocode: [35.5702377, 45.4048825],
      popUp: "سڵێمانی", // Popup for Sulaymaniyah
    },
    {
      id: 3,
      geocode: [36.2572738, 44.8834242],
      popUp: "رانیە", // Popup for Duhok
    },
  ];

  const customIcon = new Icon({
    iconUrl: require("./Image/marker-icon.png"),
    iconSize: [38, 38],
  });

  const createCustomClusterIcon = (cluster) => {
    return new divIcon({
      html: `<div class ="cluster-icon">${cluster.getChildCount()}</div>`,
      className: "custom-marker-cluster",
      iconSize: point(33, 33, true),
    });
  };
  // Function to handle marker click and redirect to Google Maps
  const handleMarkerClick = (lat, lng) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank"); // Open in a new tab
  };

  // Function to handle marker hover (show popup on mouse over)
  const handleMarkerHover = (e) => {
    e.target.openPopup(); // Opens the popup when mouse is over the marker
  };

  // Function to handle mouse out event (close popup when mouse leaves the marker)
  const handleMarkerMouseOut = (e) => {
    e.target.closePopup(); // Closes the popup when mouse leaves the marker
  };
  return (
    <div>
      <MapContainer center={[36.1545556, 44.0608333]} zoom={8}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MarkerClusterGroup
          chunkedLoading
          iconCreateFunction={createCustomClusterIcon}
        >
          {markers.map((marker) => (
            <Marker
              key={marker.id}
              position={marker.geocode}
              icon={customIcon}
              eventHandlers={{
                click: () =>
                  handleMarkerClick(marker.geocode[0], marker.geocode[1]),

                mouseover: handleMarkerHover,
                mouseout: handleMarkerMouseOut,
              }}
            >
              <Popup>{marker.popUp}</Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default MapIraq;
